export default __webpack_public_path__ + "static/media/white_check_icon.4525faeb.svg";